import FilterButtons from "../../../../components/universal-filter-tabs";
import Button from "../../../../components/Button";

export default function LabelConfigurationHeader({
  styles,
  activeTab,
  setActiveTab,
  onAdd,
}) {
  return (
    <>
      <div className={styles.sectionHeader}>
        <span className={styles.sectionIcon}>🏷️</span>
        <h2 className={styles.sectionTitle}>Label Configuration</h2>
      </div>

      <div className={styles.tabContainer}>
        <FilterButtons
          buttons={["Item Label", "Tracer Label"]}
          activeButton={activeTab}
          onButtonClick={(btn) => setActiveTab(btn)}
          className={styles.filtersCompact}
        />
        <Button className={styles.addButton} onClick={onAdd} variant="primary">
          + Add
        </Button>
      </div>
    </>
  );
}
